import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import {swal, swalError, swalLoading} from "../../../helpers/SweetAlertWrapper";
import {ChatRoomMessage, EVT_CHAT_ROOM_HIGHLIGHT_MESSAGE} from "./Messages/ChatRoomMessage";
import FuxEvents from "../../../lib/FuxFramework/FuxEvents";
import moment from "moment";
import {ADMIN_CHAT_READ_EVT, CHAT_UPDATE_MESSAGES} from "../../../const/AppEventsCostants";
import {AttachmentsAddButton} from "./Attachments/AttachmentsAddButton";
import {AudioRecordingButton} from "./AudioRecording/AudioRecordingButton";
import {AttachmentsContainer} from "./Attachments/AttachmentsContainer";
import {ReplyMessagePreview} from "../../../launcher/Tabs/ChatTab/Helpdesk/ReplyMessagePreview";

const WrapperStyle = {
    height: 'calc(100vh - 95px)',
    width: "100%",
    backgroundColor: "#dadde1",
    paddingBottom: 130
}

const MESSAGE_FETCH_LIMIT = 20;

export class MessageContextMenuAction {
    constructor(text, onClick) {
        this.text = text;
        this.onClick = onClick;
    }
}


export class ChatRoomView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            text: '',
            messages: [],
            attachments: [],
            attachmentIsAudio: false,
            afterCursor: null,
            beforeCursor: null,
            sendingMessage: false,
            isRecording: false,
        }

        this.inputRef = React.createRef();
        this.scrollPaneRef = React.createRef();
        this.shouldUpdateMessageList = true;
    }

    componentDidMount() {
        FuxEvents.on(this.props.fetchMessageEventName, this.handleExternalNewMessage);
        FuxEvents.on(CHAT_UPDATE_MESSAGES, this.handleUpdateMessages);
        this.fetchInitialMessages(MESSAGE_FETCH_LIMIT);
        this.fetchNewMessagesLoop()
    }

    componentWillUnmount() {
        FuxEvents.off(this.props.fetchMessageEventName, this.handleExternalNewMessage);
        FuxEvents.off(CHAT_UPDATE_MESSAGES, this.handleUpdateMessages);
        this.shouldUpdateMessageList = false;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //Riposiziona lo scroll del div alla posizione originale prima di aver preso messaggi più vecchi
        if (this.oldScroll !== null && this.curScrollPos !== null) {
            this.restoreScrollPoint();
        }

        if (this.state.replyToMessage && !prevState.replyToMessage && this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    fetchNewMessagesLoop = _ => {
        if (this.shouldUpdateMessageList) {
            setTimeout(_ => {
                this.fetchNewMessages(false, this.fetchNewMessagesLoop);
            }, 3000);
        }
    }


    handleUpdateMessages = id_chat_room => {
        if (id_chat_room === this.props.idRoom) {
            this.fetchInitialMessages(this.state.messages.length);
        }
    }

    handleInputChange = ({target}) => {
        if (this.state.sendingMessage) return;
        this.setState({[target.name]: target.value});
    }

    handleAttachmentsChange = attachments => this.setState({attachments: attachments});

    fetchInitialMessages = messagesNum => {
        this.props.getMessageAPI(this.props.idRoom, messagesNum, null)
            .then(data => {
                this.setState({
                    messages: data.messages.reverse(),
                    afterCursor: data.cursors.after,
                    beforeCursor: data.cursors.before,
                }, this.scrollToBottom);
            });
    }

    fetchNewMessages = (silent, onStateUpdate) => {
        return this.props.getMessageAPI(this.props.idRoom, MESSAGE_FETCH_LIMIT, this.state.afterCursor)
            .then(data => {
                if (data.messages.length) {
                    const newMessagesList = [...this.state.messages];
                    data.messages.reverse().map(m => {
                        if (!newMessagesList.find(mm => mm.id_messaggio === m.id_messaggio)) newMessagesList.push(m)
                    });

                    this.setState({
                        messages: newMessagesList,
                        afterCursor: data.cursors.after, //Aggiorno solo il cursore after
                    }, _ => {
                        if (!silent) this.scrollToBottom();
                        if (onStateUpdate) onStateUpdate();
                        if (this.props.setReadAPI) this.props.setReadAPI(this.props.idRoom).then(_ => FuxEvents.emit(ADMIN_CHAT_READ_EVT));
                    });
                } else {
                    if (onStateUpdate) onStateUpdate();
                }
            });
    }

    fetchOldMessages = _ => {
        return this.props.getMessageAPI(this.props.idRoom, MESSAGE_FETCH_LIMIT, this.state.beforeCursor)
            .then(data => {
                this.saveScrollPoint();
                this.setState({
                    messages: [...data.messages.reverse(), ...this.state.messages],
                    beforeCursor: data.cursors.before, //Aggiorno solo il cursore after
                });
            });
    }

    handleInputFormSubmit = e => {
        e.preventDefault();
        this.sendMessage();
    }

    sendMessage = _ => {
        this.setState({
            sendingMessage: true
        });
        this.inputRef.current.focus();
        this.props.sendMessageAPI(this.props.idRoom, this.state.text, this.state.attachments)
            .then(({id_messaggio, otp}) => {
                this.props.sendNotificationAPI(this.props.idRoom, id_messaggio, otp);
                this.fetchNewMessages()
                    .then(_ => {
                        this.setState({
                            sendingMessage: false,
                            text: '',
                            attachments: [],
                            attachmentIsAudio: false
                        });
                    });
            })
            .catch(message => {
                console.log(message);
                swalError(message);
                this.setState({sendingMessage: false, attachments: [], attachmentIsAudio: false});
            });

    }

    handleExternalNewMessage = id_room => {
        if (id_room === this.props.idRoom) {
            this.fetchNewMessages(false, _ => {
                const messageList = this.state.messages.slice().map(m => {
                    m.letto = "1";
                    return m;
                });
                this.setState({messages: messageList});
            });
            this.props.setReadAPI(this.props.idRoom);
        }
    }

    jumpToMessage = (id_messaggio, ttl = 10, showLoading = true) => {

        const handleMessageFound = (timeout = 1000) => {
            setTimeout(_ => {
                const element = document.querySelector(`[data-message-id="${id_messaggio}"]`);
                if (element) {
                    swal.safeClose();
                    this.scrollPaneRef.current.scrollTo({top: element.offsetTop - 100, behavior: 'smooth'});
                    FuxEvents.emit(EVT_CHAT_ROOM_HIGHLIGHT_MESSAGE, id_messaggio);
                } else {
                    this.jumpToMessage(id_messaggio, 0, false); //Mostra errore
                }
            }, timeout)
        }

        if (this.state.messages.find(m => m.id_messaggio == id_messaggio)) return handleMessageFound(0);

        if (!ttl) return swalError("Impossibile trovare il messaggio. Potrebbe essere troppo vecchio oppure potrebbe trattarsi di un problema di connessione, riprova più tardi.");
        if (showLoading) swalLoading('Attendere prego...');

        this.props.getMessageAPI(this.props.idRoom, MESSAGE_FETCH_LIMIT, this.state.beforeCursor)
            .then(data => {
                let messageFound = false;
                let hasNewMessages = false;
                const newMessagesList = [...data.messages.reverse()];
                (this.state.messages || []).map(m => {
                    if (!newMessagesList.find(mm => mm.id_messaggio === m.id_messaggio)) {
                        newMessagesList.push(m);
                        hasNewMessages = true;
                    }
                    if (m.id_messaggio == id_messaggio) messageFound = true;
                });
                this.setState({messages: newMessagesList, beforeCursor: data.cursors.before}, _ => {
                    if (messageFound) {
                        handleMessageFound();
                    } else if (hasNewMessages) {
                        this.jumpToMessage(id_messaggio, ttl - 1, false);
                    } else {
                        this.jumpToMessage(id_messaggio, 0, false); //Mostra errore
                    }
                });
            });
    }

    handleGoToReplyMessage = message => this.jumpToMessage(message.id_messaggio);


    /** @MARK: Scroll utilities */

    scrollToBottom = _ => {
        if (this.scrollPaneRef.current) {
            this.scrollPaneRef.current.scrollTop = this.scrollPaneRef.current.scrollHeight;
        }
    }

    saveScrollPoint = _ => {
        if (this.scrollPaneRef.current) {
            this.curScrollPos = this.scrollPaneRef.current.scrollTop;
            this.oldScroll = this.scrollPaneRef.current.scrollHeight - this.scrollPaneRef.current.clientHeight;
        }
    }

    restoreScrollPoint = _ => {
        if (this.oldScroll !== null && this.curScrollPos !== null) {
            const newScroll = this.scrollPaneRef.current.scrollHeight - this.scrollPaneRef.current.clientHeight;
            this.scrollPaneRef.current.scrollTop = this.curScrollPos + (newScroll - this.oldScroll);
            this.oldScroll = null;
            this.curScrollPos = null;
        }
    }

    /** @MARK: Recording management */

    handleRecordingChange = isRecording => this.setState({
        isRecording: isRecording,
        recordingStartTime: isRecording ? (new Date()).getTime() : null
    });

    handleRecordingAudioFile = audio => {
        this.setState({attachments: [audio], attachmentIsAudio: true}, _ => this.sendMessage());
    }


    render() {
        return (
            <div ref={this.scrollPaneRef} className={"position-relative pt-4 overflow-auto"} style={WrapperStyle}>
                <div className={"px-3"}>
                    {
                        !this.state.messages &&
                        <div className={"w-75 mx-auto bg-white small p-2 rounded shadow-sm"}>
                            Non ci sono ancora messaggi in questa chat
                        </div>
                    }
                    {
                        !!this.state.beforeCursor &&
                        <div className={"text-center"} onClick={this.fetchOldMessages}>
                            <button className={"btn btn-sm btn-link text-primary"}>
                                Carica messaggi precedenti
                            </button>
                        </div>
                    }
                    {
                        this.state.messages.map((m, i) => {
                            const prevMessage = i === 0 ? null : this.state.messages[i - 1];
                            const nextMessage = i === this.state.messages.length - 1 ? null : this.state.messages[i + 1];
                            const isLast = !nextMessage || nextMessage.id_mittente !== m.id_mittente;

                            const messageData = this.props.messageProcessor ? this.props.messageProcessor(m) : m;
                            const widget = this.props.messageWidgetRenderer ? this.props.messageWidgetRenderer(m, i == this.state.messages.length - 1) : null;
                            const decorator = this.props.messageDecoratorRenderer ? this.props.messageDecoratorRenderer(m, i == this.state.messages.length - 1) : null;
                            const sender = this.props.messageSenderRenderer ? this.props.messageSenderRenderer(m) : '';

                            const showOwnDate = !prevMessage || moment(prevMessage.data_creazione).format('DD-MM-YYYY') !== moment(m.data_creazione).format('DD-MM-YYYY');
                            const isMine = parseInt(m.id_mittente) === parseInt(this.props.idSelf);

                            return <ChatRoomMessage
                                key={m.id_messaggio}
                                messageData={messageData}
                                idSelf={this.props.idSelf}
                                isLast={isLast}
                                showOwnDate={showOwnDate}
                                getMediaContentUrlAPI={this.props.getMediaContentUrlAPI}
                                getMediaContentPreviewUrlAPI={this.props.getMediaContentPreviewUrlAPI}
                                widget={widget}
                                decorator={decorator}
                                sender={sender}
                                messageContextMenuActions={isMine ? this.props.ownMessageContextMenuActions : this.props.otherMessageContextMenuActions}
                                onGotoToReplyMessage={this.handleGoToReplyMessage}
                            />
                        })
                    }
                </div>
                <div className={"bg-white shadow-sm position-fixed fixed-bottom p-2 border-top"}>
                    {
                        !!this.props.replyToMessage &&
                        <div className={"w-100 mb-2"}>
                            <ReplyMessagePreview
                                message={this.props.replyToMessage}
                                onCancel={this.props.onReplyCancel}
                                idSelf={this.props.idSelf}
                            />
                        </div>
                    }
                    {
                        (this.state.attachments.length > 0 && !this.state.attachmentIsAudio) &&
                        <AttachmentsContainer
                            attachments={this.state.attachments}
                            onChange={this.handleAttachmentsChange}
                            disabled={this.state.sendingMessage}
                        />
                    }
                    <div className={"d-flex align-items-center"}>
                        <form onSubmit={this.handleInputFormSubmit}
                              className={this.state.isRecording ? 'd-none' : 'flex-grow-1'}>
                            <div className={"input-group"}>
                                <div className={"input-group-prepend"}>
                                    <AttachmentsAddButton
                                        attachments={this.state.attachments}
                                        onChange={this.handleAttachmentsChange}
                                        disabled={this.state.sendingMessage}
                                    />
                                </div>
                                <input
                                    ref={this.inputRef}
                                    className={"form-control rounded-pill"}
                                    type={"text"}
                                    name={"text"}
                                    value={this.state.text}
                                    onChange={this.handleInputChange}
                                />
                                <div className={"input-group-append"}>
                                    <button style={{width: 38, height: 38}}
                                            className={"btn btn-primary rounded-circle d-flex align-items-center justify-content-center ml-2"}
                                            disabled={(!this.state.text && this.state.attachments.length === 0) || this.state.sendingMessage}
                                            onClick={this.sendMessage}>
                                        {
                                            this.state.sendingMessage ?
                                                <FaSolidIcon name={"spin"} className={"fa-spinner"}/>
                                                :
                                                <FaSolidIcon name={"paper-plane"}/>
                                        }
                                    </button>
                                </div>
                            </div>
                        </form>
                        {
                            this.props.showAudioRecordingButton &&
                            <AudioRecordingButton
                                onRecordingChange={this.handleRecordingChange}
                                isRecording={this.state.isRecording}
                                onAudioFile={this.handleRecordingAudioFile}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }

}

ChatRoomView.propTypes = {
    idRoom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idSelf: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    getMessageAPI: PropTypes.func.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
    getMediaContentPreviewUrlAPI: PropTypes.func.isRequired,
    sendMessageAPI: PropTypes.func.isRequired,
    setReadAPI: PropTypes.func.isRequired,
    sendNotificationAPI: PropTypes.func.isRequired,
    fetchMessageEventName: PropTypes.string.isRequired,
    showAudioRecordingButton: PropTypes.bool,
    messageProcessor: PropTypes.func,
    messageWidgetRenderer: PropTypes.func,
    messageDecoratorRenderer: PropTypes.func,
    messageSenderRenderer: PropTypes.func,
    ownMessageContextMenuActions: PropTypes.array,
    otherMessageContextMenuActions: PropTypes.array,
    replyToMessage: PropTypes.object,
    onReplyCancel: PropTypes.func
}

ChatRoomView.defaultProps = {
    showAudioRecordingButton: false
}
